import _extends from "@babel/runtime/helpers/extends";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import omit from "just-omit";
import Loading from "../Loading";
import styles from "./FieldFrame.module.css";

const FieldFrame = props => {
  const {
    hasError,
    errorMessage,
    disabled,
    label,
    className,
    children,
    icon,
    isLoading,
    size,
    value,
    withShadow,
    isRtl
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.fieldFrame, {
      [styles.withShadow]: withShadow,
      [className]: className,
      hasError: hasError || errorMessage,
      disabled
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.fieldContainer
  }, label && /*#__PURE__*/React.createElement("span", {
    className: cx(styles.fieldLabel, {
      [styles.labelWithValue]: !!value,
      [styles.rtl]: isRtl
    })
  }, label), icon && /*#__PURE__*/React.createElement("span", {
    className: cx(styles.fieldIcon, {
      [styles.rtl]: isRtl
    })
  }, icon), children.type ? /*#__PURE__*/React.createElement(children.type, _extends({
    className: cx(styles.fieldControl, styles[size], {
      [styles.withIcon]: icon,
      [styles.rtl]: isRtl
    }),
    ref: children.props.forwardedRef
  }, omit(children.props, "forwardedRef"))) : children({
    className: cx(styles.fieldControl, styles[size], styles.noPadding)
  }), isLoading && /*#__PURE__*/React.createElement(Loading, {
    className: styles.loading
  })), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: styles.fieldError
  }, errorMessage));
};

FieldFrame.propTypes = {
  withShadow: PropTypes.bool,
  label: PropTypes.string,
  icon: PropTypes.element,
  hasError: PropTypes.bool,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  value: PropTypes.any,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  isRtl: PropTypes.bool
};
FieldFrame.defaultProps = {
  withShadow: false,
  icon: null,
  label: null,
  hasError: false,
  disabled: false,
  errorMessage: null,
  className: null,
  size: "md",
  isLoading: false,
  value: undefined,
  isRtl: false
};

const _default = /*#__PURE__*/React.memo(FieldFrame);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(FieldFrame, "FieldFrame", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/FieldFrame/FieldFrame.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/FieldFrame/FieldFrame.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();